"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderLicense = void 0;
class ProviderLicense {
    constructor(props) {
        this.active = props?.active || false;
        this.defaultLicense = props?.defaultLicense || false;
        this.jurisdiction = props?.jurisdiction || null;
        this.nationality = props?.nationality || null;
        this.number = props?.number || null;
        this.uid = props?.uid || null;
        this.autoValidation = props?.autoValidation || false;
        this.district = props?.district || null;
        this.especialidad_date = props?.especialidad_date || null;
        this.especialidad_tipo = props?.especialidad_tipo || null;
        this.especialidad = props?.especialidad || null;
        this.manualValidation = props?.manualValidation || false;
        this.profesion = props?.profesion || null;
        this.provincia = props?.provincia || null;
        this.timestamps = props?.timestamps || null;
    }
}
exports.ProviderLicense = ProviderLicense;
